export default "__VITE_ASSET__CI3jbxGG__"